import React, { useEffect } from 'react';
import Header from './header/Header';
import Progress from '../controls/Progress';
import { getClaimRouteOrder, getSteps, RoutePrefixes } from '../../routing/RouteNames';
import { AppState } from '../../store/store';
import { connect, ResolveThunks } from 'react-redux';
import { redirectToHome } from '../../routing/RouteActions';
import { getRelativeCurrentUrl } from '../../common/utils/URLUtils';

interface Props {
  children?: React.ReactNode;
  hideLogo?: boolean;
  showProgress?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  hideLogo,
  showProgress = false,
  incident,
  isMotionsCloudEnabled,
  redirectToHome,
}: LayoutProps) => {
  useEffect(() => {
    const currentRoute = getRelativeCurrentUrl();
    if (currentRoute.includes(RoutePrefixes.CLAIMS)) {
      redirectToHome(incident, isMotionsCloudEnabled);
    }
  }, []);
  return (
    <>
      <header id='header'>
        <Header hideLogo={hideLogo} />
        {showProgress && (
          <Progress
            total={getSteps(isMotionsCloudEnabled, incident)}
            currentStep={getClaimRouteOrder(isMotionsCloudEnabled, incident)}
          />
        )}
      </header>
      {children}
    </>
  );
};

const mapStateToProps = ({ claimIncident, claim }: AppState) => ({
  incident: claimIncident.incident,
  isMotionsCloudEnabled: claim.isMotionsCloudEnabled,
});

const mapDispatchToProps = {
  redirectToHome: redirectToHome,
};

export type LayoutProps = Props &
  ReturnType<typeof mapStateToProps> &
  ResolveThunks<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
